import { Component, OnInit } from '@angular/core';
import {combineLatest, Observable} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {FondsMitAnteil} from '../../../../models/fondsMitAnteil';
import {FondsService} from '../../../../services/fonds.service';
import {EventService} from '../../../../services/event.service';
import {Fonds} from '../../../../models/fonds';
import {UiControl} from '../../../../models/uiControl';
import {map} from 'rxjs/operators';
import {flatMap, ListControl} from '../../../../models/uiArtefakt';

@Component({
    selector: 'lv-anlauf-management-uebersicht-table',
    templateUrl: './anlauf-management-uebersicht-table.component.html',
    styleUrls: ['./anlauf-management-uebersicht-table.component.scss'],
    standalone: false
})
export class AnlaufManagementUebersichtTableComponent implements OnInit {
  public anlaufmanagementFonds$: Observable<MatTableDataSource<FondsMitAnteil>>;
  constructor(private _fondsService: FondsService, private _eventService: EventService) { }

  ngOnInit(): void {
    this.anlaufmanagementFonds$ = combineLatest<[Fonds[], UiControl]>([
      this._fondsService.getAllFonds(), this._eventService.uiControls$]).pipe(
        map(([fonds, uiControl]) => {
          const listControl = flatMap(uiControl.uiVorgang.UIArtefakt).filter(uiArtefakt =>
              '/listePortfolioAnlaufmanagement' === uiArtefakt.FeldnameExtern)[0] as ListControl;
          const fondsMitAnteil = this._fondsService.getAnlaufAblaufmanagementFonds(fonds, listControl);
          return new MatTableDataSource([fondsMitAnteil]);
        })
    );
  }

}
